import { UserTask } from '../../models';

export interface State {
  activeUserTasks: Array<UserTask<any>> | null;
}

export const initialState: State = {
  activeUserTasks: null,
};
